import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { meGQL } from "@onmo/graphql/graphql";
import { find } from "lodash-es";
import { ActiveIframe } from "../../components/common/GameFeed/ActiveIframe";
import { RewardScreen } from "../../components/common/RewardScreen";
import { useAppDispatch, useAppSelector } from "../../components/hooks";
import { updateUser } from "../../store/slices/user";
import { User } from "../../models/user";
import { PageRoutes } from "../../constants/historyGaming";
import { useStyles } from "./PlayIframe.style";
import { serviceLinkMap } from "../../hooks/useDirectoryData";
import { setIsShowService } from "../../store/slices/popup";
import { useFeaturedCards } from "../../hooks/useFeaturedCards";
import { HomepageMd } from "../../models/homepage";

export const PlayIframe = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.user);
  const { data: dataMe, refetch } = useQuery(meGQL);
  const [activeIframe, setActiveIframe] = useState("");
  const [rewardAmount, setRewardAmount] = useState(0);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const feedId = params.get("feedId");
  const category = params.get("category");
  const homeFeed = useFeaturedCards();

  const navigate = useNavigate();

  const handleCloseIframe = async () => {
    const userUpdate = await refetch();
    setActiveIframe("");
    if (user && userUpdate?.data?.me) {
      const oldGzCoin = User.getGzCoin(user?.coinWallets);
      const newGzCoin = User.getGzCoin(userUpdate?.data?.me?.coinWallets);
      if (oldGzCoin !== newGzCoin) {
        setRewardAmount(newGzCoin - oldGzCoin);
      } else {
        navigate(PageRoutes.HomePage);
        dispatch(setIsShowService({ isShowService: false }));
      }
    }
  };

  useEffect(() => {
    if (category) return;
    const gameFeed = find(homeFeed, { id: feedId });
    if (!gameFeed) return;
    setActiveIframe(HomepageMd.getLink(gameFeed));
  }, [feedId, homeFeed]);

  useEffect(() => {
    if (feedId || !category) return;
    const categoryLink = serviceLinkMap[category];
    if (!categoryLink) return;
    setActiveIframe(categoryLink);
  }, [category]);

  useEffect(() => {
    if (dataMe?.me) {
      dispatch(updateUser({ user: dataMe?.me }));
    }
  }, [dataMe]);

  return (
    <div>
      {activeIframe && (
        <ActiveIframe
          iframeUrl={activeIframe}
          onCloseIframe={handleCloseIframe}
          feedId={feedId ?? ""}
        />
      )}
      {rewardAmount !== 0 && (
        <RewardScreen
          className={classes.endScreen}
          rewardAmount={rewardAmount}
        />
      )}
    </div>
  );
};
